import React from "react";
import {
  Image,
  Page,
  Document,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import Encabezado from "./assets/encabezado.png";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "/fonts/Roboto-Regular.ttf" },
    { src: "/fonts/Roboto-Bold.ttf", fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
  },
  page: {
    fontFamily: "Roboto",
    fontSize: 10,
    textAlign: "justify",
    paddingTop: 125,
    paddingBottom: 40,
    paddingHorizontal: 30,
  },
  titleContainer: {
    position: "absolute",
    top: 55,
    left: 0,
    width: "100%",
    textAlign: "center",
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    marginTop: 20,
  },
  fechaTitle: {
    fontWeight: "bold",
  },
  section: {
    marginBottom: 10,
  },
  clauseTitle: {
    marginTop: 12,
    fontWeight: "bold",
  },
  firma: {
    marginTop: 50,
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    textAlign: "center",
    fontSize: 10,
    color: "#555",
  },
});

const ContratoPDFDocument = ({ datos }) => {
  if (!datos) return null; // previene errores
  const getEmpresaTexto = () => {
    switch (datos.empresaFactura) {
      case "cata":
        return `Entre la empresa CATA Internacional L.T.D.A. / CUIT Nº 33-54662883-9, con domicilio legal en Diamante 550 Godoy Cruz, Provincia de Mendoza, en adelante denominada "El Prestador", y el cliente `;
      case "mitre":
        return `Entre la empresa Transp. Gral. Bartolomé Mitre S.R.L. / CUIT Nº 30-54627327-6, con domicilio legal en Bandera de los Andes 1507 San José, Guaymallén, Provincia de Mendoza, en adelante denominada "El Prestador", y el cliente `;
      default:
        return `Entre la empresa AUTOTRANSPORTES TUPUNGATO S.A. / CUIT Nº 30-70313484-6, con domicilio legal en Diamante 550 Godoy Cruz, Provincia de Mendoza, en adelante denominada "El Prestador", y el cliente `;
    }
  };
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <View fixed style={styles.backgroundImage}>
          <Image src={Encabezado} style={styles.backgroundImage} />
        </View>

        <View fixed style={styles.titleContainer}>
          <Text style={styles.title}>
            Contrato para Servicio Especial de Transporte.
          </Text>
        </View>

        <View>
          <Text style={styles.fechaTitle}>
            En la ciudad de Mendoza, República Argentina. Con fecha{" "}
            {new Date(
              new Date(datos.fecha).toLocaleString("en-US", {
                timeZone: "UTC",
              })
            ).toLocaleDateString("es-ES")}
          </Text>

          <Text style={styles.section}>
            Contrato:{"  "}
            {datos.contratoNumero}
          </Text>

          <Text>
            {getEmpresaTexto()} {datos.nombreApellido}, con DNI / CUIT / CUIL{" "}
            {datos.nombreApellido === "CLUB ATLETICO GIMNASIA Y ESGRIMA"
              ? "30-67640243-4"
              : datos.dni}
            , en adelante denominado "El Cliente". Ambas partes acuerdan
            celebrar el presente Documento para la contratación de un servicio
            especial de transporte, de conformidad con las siguientes cláusulas:
          </Text>

          <Text style={styles.clauseTitle}>1. Objeto del Contrato</Text>
          <Text>
            Este contrato tiene como objetivo principal formalizar el acuerdo
            para el servicio de transporte especial presupuestado. Define la
            responsabilidad del Cliente y cuidado de las instalaciones de las
            unidades proporcionadas por El Prestador.
          </Text>

          <Text style={styles.clauseTitle}>2. Descripción de la Unidad</Text>
          <Text style={styles.section}>
            El Prestador cede en locación al Cliente un bus {datos.tipoBus} de{" "}
            {datos.pisos}, con capacidad para {datos.butacas} pasajeros. Unidad
            equipada:
            {datos.elementosConfort}. Dicha unidad será utilizada exclusivamente
            para el traslado de los pasajeros declarados, de acuerdo con el
            itinerario presupuestado que se detalla a continuación:
          </Text>
          {datos.destino === "receptivos" ? (
            <>
              <Text>
                - Fecha de inicio:{" "}
                {new Date(
                  new Date(datos.fechaSalida).toLocaleString("en-US", {
                    timeZone: "UTC",
                  })
                ).toLocaleDateString("es-ES")}{" "}
                - Hora: {datos.horaSalida} h.
              </Text>
              <Text>- Ciudad / Lugar: {datos.origen}.</Text>
              <Text>
                - Finalización del servicio:{" "}
                {new Date(
                  new Date(datos.fechaRegreso).toLocaleString("en-US", {
                    timeZone: "UTC",
                  })
                ).toLocaleDateString("es-ES")}
              </Text>

              <Text>- Movimientos Receptivos</Text>
            </>
          ) : (
            <>
              <Text>
                - Fecha de salida:{" "}
                {new Date(
                  new Date(datos.fechaSalida).toLocaleString("en-US", {
                    timeZone: "UTC",
                  })
                ).toLocaleDateString("es-ES")}{" "}
                - Hora: {datos.horaSalida} h.
              </Text>
              <Text>- Desde: {datos.origen}.</Text>

              <Text>- Hasta: {datos.destino}</Text>
              <Text>
                - Regreso:{" "}
                {new Date(
                  new Date(datos.fechaRegreso).toLocaleString("en-US", {
                    timeZone: "UTC",
                  })
                ).toLocaleDateString("es-ES")}{" "}
                - Hora: {datos.horaRegreso} h.
              </Text>
            </>
          )}

          {datos.kmEnDestino && datos.kmEnDestino !== 0 && (
            <>
              <Text>
                - Kilómetros permitidos en destino: {datos.kmEnDestino}
              </Text>
              <Text>
                - En la cotización se incluyen kms por desvíos en caso de
                emergencias o necesidades operativas.
              </Text>
            </>
          )}
          <Text>
            - Otras condiciones: Posteriormente en la cláusula 15 del presente
            contrato, se detallará el itinerario correspondiente y otras
            condiciones o consideraciones específicas para la prestación del
            servicio.
          </Text>
          <Text>
            El Prestador podrá reemplazar la unidad asignada al servicio por
            otra de similares características, en caso de:
          </Text>
          <Text>
            a) Fallas mecánicas o técnicas que imposibiliten su operatividad
            segura;
          </Text>
          <Text>
            b) Necesidad de destinar la unidad a otro servicio previamente
            contratado;
          </Text>
          <Text>
            c) Requerimientos de mantenimiento preventivo o correctivo urgentes.
          </Text>
          <Text>
            El reemplazo será notificado al Cliente con al menos 48 horas de
            anticipación, salvo en casos de emergencia inmediata. La unidad
            sustituta deberá contar con condiciones equivalentes a la
            originalmente pactada.
          </Text>

          <Text style={styles.clauseTitle}>3. Precio y Pago</Text>
          <Text>
            El Cliente abona como precio total del presente contrato la suma de{" "}
            {new Intl.NumberFormat("es-AR", {
              style: "currency",
              currency: "ARS",
            }).format(datos.tarifaTotal)}
            {" ("}pesos {datos.montoEnLetras}, con 00/100{")"}, con la forma de
            pago: {datos.formaDePago}, tipo de moneda o número de comprobante:{" "}
            {datos.comprobanteDePago}. Los gastos o servicios extras no
            especificados en el presente contrato, necesarios para los
            diferentes traslados como peajes o estacionamientos serán de
            exclusiva responsabilidad del Cliente.
          </Text>

          <Text style={styles.clauseTitle}>4. Conductores</Text>
          <Text>
            Los conductores de la unidad en la presente locación serán
            suministrados por El Prestador.
          </Text>

          <Text style={styles.clauseTitle}>5. Seguro y Responsabilidad</Text>
          <Text>
            El seguro de responsabilidad civil frente a terceros y por pasajeros
            transportados será a cargo de El Prestador. Las reclamaciones de
            terceros y/o pasajeros que no tengan vinculación con el hecho del
            transporte, ni resulten cubiertos por la póliza respectiva, serán
            atendidos por el Cliente, quien desobliga específicamente a El
            Prestador de toda responsabilidad y asumirá su defensa plena e
            irrestricta en caso de resultar necesario.
          </Text>

          <Text style={styles.clauseTitle}>
            6. Cuidado y Protección de las Instalaciones
          </Text>
          <Text>
            El Cliente se compromete a tomar todas las medidas necesarias para
            asegurar el cuidado y protección de las instalaciones de la unidad
            durante el servicio especial de transporte. Los automotores se
            proveen con sus interiores, butacas, cortinas y elementos de confort
            en perfecto estado de funcionamiento. Los daños que produjeren los
            pasajeros y/o terceros serán cubiertos por el Cliente. A tal fin, al
            término del contrato, se labrará un acta en la que se detallarán los
            daños y el costo de las reparaciones, y que el Cliente acepta como
            válidas.
          </Text>
          <Text>El Cliente se compromete a:</Text>
          <Text>
            a) Utilizar las instalaciones de acuerdo con las instrucciones
            proporcionadas por El Prestador y de acuerdo con las leyes y
            reglamentos vigentes.
          </Text>
          <Text>
            b) Evitar cualquier acto negligente, deliberado o imprudente que
            pueda dañar las instalaciones.
          </Text>
          <Text>
            c) Informar inmediatamente a El Prestador sobre cualquier daño o
            incidente ocurrido durante el servicio.
          </Text>
          <Text>
            d) Reembolsar a El Prestador por cualquier costo asociado a la
            reparación o reemplazo de las instalaciones en caso de daños
            causados por el Cliente o sus representantes.
          </Text>

          <Text style={styles.clauseTitle}>
            7. Posibles daños a la unidad, limpieza extraordinaria y/o multas
            derivadas del servicio
          </Text>
          <Text>
            El Cliente podrá contratar, a su exclusivo cargo, una póliza de
            seguro de caución a favor de El Prestador, por un monto equivalente
            a {datos.montoPagare}, destinada a cubrir posibles daños a la
            unidad, limpieza extraordinaria y/o multas derivadas del servicio.
            La póliza deberá tener una vigencia mínima hasta 30 días posteriores
            a la finalización del servicio. En caso de no presentar dicha póliza
            antes del inicio del servicio, El Cliente reconoce y acepta que
            asume toda responsabilidad por los conceptos antes mencionados, y
            que, a efectos contractuales, se entenderá que opta por contratar la
            cobertura equivalente ofrecida por El Prestador, bajo las
            condiciones y montos estipulados en el presente contrato.
          </Text>

          <Text style={styles.clauseTitle}>
            8. Exoneración de Responsabilidad
          </Text>
          <Text>
            El Prestador no será responsable por los daños causados por el uso
            indebido, negligencia, actos intencionales o imprudentes del Cliente
            o sus representantes. El Prestador tampoco será responsable por
            daños ocasionados por causas o circunstancias imprevistas que estén
            fuera de su control.
          </Text>

          <Text style={styles.clauseTitle}>
            9. Responsabilidad en la Documentación de Menores
          </Text>
          <Text style={styles.section}>
            Es obligatorio que los menores de 18 años que viajen dentro del país
            cumplan con la documentación requerida. El Cliente asume la plena
            responsabilidad de contar con la documentación en el caso de viajar
            con menores de edad de acuerdo a lo establecido en la Resolución N°
            43/16 del Ministerio de Transporte y la Resolución N° 1025/16 de la
            CNRT. El Cliente reconoce y acepta que en caso de que un menor de
            edad viaje se aplique el siguiente protocolo:
          </Text>
          <Text>
            • Si el menor viaja acompañado por su representante legal, este debe
            llevar consigo su documento de identidad y el del menor.
          </Text>
          <Text>
            • Si el documento del menor no menciona a su representante legal o
            no cumple con los requisitos necesarios, será responsabilidad del
            representante llevar una partida de nacimiento, acta de nacimiento o
            testimonio judicial de adopción que acredite el vínculo familiar,
            junto con sus propios documentos de identidad.
          </Text>
          <Text>
            • Si el menor viaja con una persona que no sea su representante
            legal, se requiere un permiso de autorización del representante
            legal, acompañado de la partida de nacimiento del menor y documento
            de ambos.
          </Text>
          <Text>
            El Cliente comprende y acepta que si El Prestador o su grupo de
            empresas son multados debido a alguna irregularidad en la
            documentación, el monto de la multa será trasladado al presupuesto
            del Cliente y este será responsable de cubrirlo. Para completar este
            trámite, el adulto responsable del menor debe presentarse antes de
            la salida del servicio con la documentación requerida. Con el
            propósito de verificar y validar que tanto los datos como la
            documentación presentada sean correctos y cumplan con los requisitos
            estipulados por las resoluciones mencionadas.
          </Text>

          <Text style={styles.clauseTitle}>10. Cancelación del Servicio</Text>
          <Text style={styles.section}>
            Si el Cliente decide cancelar el servicio después de la firma de
            este contrato, se aplicará una multa de acuerdo con la siguiente
            escala:
          </Text>
          <Text>
            • Si la cancelación se notifica con hasta 72 horas de anticipación,
            se retendrá el 10% del importe total presupuestado.
          </Text>
          <Text>
            • En caso de que la cancelación se realice entre 72 y 48 horas antes
            del servicio programado, se retendrá el 15% del importe total
            presupuestado.
          </Text>
          <Text>
            • Si la cancelación se efectúa entre 48 y 24 horas antes del
            servicio programado, se retendrá el 25% del importe total
            presupuestado.
          </Text>
          <Text>
            • Pasado ese plazo, si no se notifica la cancelación y no se hace
            uso del servicio, el Cliente será responsable de abonar el importe
            total del servicio contratado.
          </Text>

          <Text style={styles.clauseTitle}>10.1 Justificación de la Multa</Text>
          <Text>
            La multa tiene como finalidad compensar los costos administrativos
            asociados a la gestión de la reserva de unidades, la planificación
            logística del servicio, la posible pérdida de otros servicios debido
            a la reserva previa y los gastos relacionados con la contratación de
            servicios terciarizados, como empresas de catering, que pudieron
            haber sido programados en el cumplimiento del servicio.
          </Text>

          <Text style={styles.clauseTitle}>
            11. Tipo de Cliente y pago del servicio
          </Text>
          <Text>
            Los clientes con servicios recurrentes semanales o mensuales y
            clientes eventuales con servicios únicos tendrán una vigencia
            detallada en la cláusula 14 y un metodo de pago específico detallado
            a continuación.
          </Text>

          <Text style={styles.clauseTitle}>
            11.1. Servicios Semanales o Mensuales
          </Text>
          <Text style={styles.section}>
            Para la liquidación y facturación semanal se emitirá los días lunes
            de la semana siguiente a los servicios y el pago total deberá
            realizarse dentro de los 10 días hábiles posteriores a la recepción
            de la factura. Para la facturación mensual los servicios prestados
            se consolidarán en una liquidación emitida entre el día 1 y 5 del
            mes siguiente. El pago total deberá realizarse dentro de los 10 días
            hábiles posteriores a la recepción de la factura. La modalidad de
            facturación (semanal/mensual) se acordará por escrito junto al
            itinerario y otras observaciones y no podrá modificarse sin
            consentimiento mutuo. La actualización de precios será trimestral:
          </Text>
          <Text>
            • Los montos pactados se ajustarán cada 3 meses según los costos de
            transporte publicados por FEDEEAC.
          </Text>
          <Text>
            • El Prestador notificará los nuevos valores al inicio de cada
            trimestre mediante email.
          </Text>
          <Text>
            • Intereses por Mora: En caso de demora en el pago, se aplicarán
            intereses equivalentes a la Tasa Activa del Banco de la Nación
            Argentina vigente al momento del vencimiento (*Art. 767 CCyCN*).
          </Text>
          <Text>
            • Terminación del Contrato: Durante los primeros 6 meses, el
            contrato solo podrá rescindirse por incumplimiento grave, pasados
            los 6 meses, cualquier parte podrá terminarlo notificando con 30
            días de anticipación. El Prestador cobrará únicamente los servicios
            efectivamente prestados hasta la fecha de terminación.
          </Text>

          <Text style={styles.clauseTitle}>
            11.2. Clientes Eventuales (Servicios Únicos)
          </Text>
          <Text>
            El pago total del servicio deberá realizarse antes de la fecha de
            salida programada. Si el pago no se completa 24 horas previas al
            servicio el servicio se suspenderá automáticamente y se aplicará una
            multa del 15% del valor total por gastos administrativos y
            logísticos irreversibles. Si el servicio ya fue ejecutado y el pago
            es parcial o nulo el saldo adeudado generará intereses diarios según
            la tasa mencionada. El Prestador podrá iniciar acciones legales.
          </Text>

          <Text style={styles.clauseTitle}>
            11.3. Facturación y Métodos de Pago
          </Text>
          <Text>
            Todas las facturas se emitirán en pesos argentinos, con detalle de
            IVA y cargos adicionales (peajes, estacionamientos, etc.). Métodos
            aceptados: transferencia bancaria, tarjeta de crédito (con recargo
            del 5%), o efectivo. Los pagos en efectivo superiores a $300.000
            deberán realizarse mediante depósito bancario para cumplir con la
            Ley 25.246 (prevención de lavado de dinero).
          </Text>

          <Text style={styles.clauseTitle}>
            12. Incumplimiento de Pago, Intereses por Mora y Acciones Legales
          </Text>
          <Text style={styles.section}>
            En caso de incumplimiento del pago por parte del Cliente, se
            aplicarán las siguientes consecuencias:
          </Text>
          <Text>
            • Intereses por Mora: Cualquier pago atrasado incurrirá en intereses
            por mora. La tasa de interés será la tasa activa del Banco Nación
            vigente en Argentina. Los intereses se acumularán diariamente desde
            la fecha de vencimiento hasta la fecha de pago completo.
          </Text>
          <Text>
            • Acciones Legales: El Prestador se reserva el derecho de tomar
            acciones legales para recuperar el monto adeudado. Esto puede
            incluir, pero no se limita a, el inicio de procedimientos judiciales
            y la contratación de servicios de cobranza.
          </Text>
          <Text>
            Por lo tanto, se insta al Cliente a realizar todos los pagos a
            tiempo para evitar estas consecuencias.
          </Text>

          <Text style={styles.clauseTitle}>
            13. Resolución de Controversias
          </Text>
          <Text>
            Cualquier controversia derivada de este contrato será resuelta
            mediante negociación de buena fe entre ambas partes. En caso de no
            llegar a un acuerdo, las partes acuerdan someterse a la jurisdicción
            de los tribunales competentes de la Provincia de Mendoza para
            resolver dichas controversias.
          </Text>

          {datos.servicioMensual === "si" ? (
            <>
              <Text style={styles.clauseTitle}>14. Vigencia del Contrato</Text>
              <Text>
                Tendrá una vigencia inicial de 6 meses, renovándose
                automáticamente por periodos mensuales hasta completar 12 meses.
                Cualquiera de las partes podrá notificar la terminación con 30
                días de anticipación, sin necesidad de invocar causa alguna.
                Finalizados los 12 meses, el contrato se considerará extinguido,
                salvo que las partes acuerden por escrito una prórroga. En caso
                de incumplimiento del Cliente, El Prestador podrá suspender los
                servicios y/o exigir el cumplimiento mediante acciones legales,
                sin perjuicio de otros derechos (*Art. 1024 CCyCN*).
              </Text>
            </>
          ) : (
            <>
              <Text style={styles.clauseTitle}>14. Vigencia del Contrato</Text>
              <Text>
                Tendrá vigencia exclusiva durante la ejecución del servicio.
                Finalizado el servicio, el contrato se considerará extinguido.
                En caso de incumplimiento del Cliente, El Prestador podrá exigir
                el cumplimiento mediante acciones legales, sin perjuicio de
                otros derechos (*Art. 1024 CCyCN*).
              </Text>
            </>
          )}

          <Text style={styles.clauseTitle}>
            15. Itinerario y Otras Condiciones del Servicio
          </Text>
          <Text>{datos.observaciones}</Text>

          <View wrap={false}>
            <Text style={styles.clauseTitle}>16. Jurisdicción</Text>
            <Text style={styles.section}>
              Ambas partes aceptan la jurisdicción de los tribunales ordinarios
              de la Provincia de Mendoza, a cuyo fin constituyen domicilio en
              los declarados supra denunciados, renunciando expresamente a
              cualquier otro fuero en especial al federal.
            </Text>

            <Text style={styles.section}>
              En señal de conformidad, se firma el presente contrato, en el
              lugar y fecha mencionados anteriormente.
            </Text>
            <Text style={styles.firma}>
              Firma del Cliente: ______________________
              Aclaración:______________________
            </Text>
          </View>
        </View>
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Página ${pageNumber} de ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};
export default ContratoPDFDocument;
